<template>
  <div>
    <v-container class="col-12 ml-0 mt-10 pl-0 pb-3">
      <v-row :style="searchHeight" class="mb-4 ml-0" cols="12">
        <v-col cols="2" :style="searchHeight" class="pl-0 pb-0 pt-6">접수일</v-col>
        <v-col cols="4">
          <v-menu v-model="startMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.from"
                readonly
                v-on="on"
                dense
                :style="textFileSize"
                class="d-inline-block mr-1"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="searchPayload.from" @input="startMenu = false" locale="ko" :max="searchPayload.to"></v-date-picker>
          </v-menu>
          ~
          <v-menu v-model="endMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.to"
                readonly
                v-on="on"
                dense
                :style="textFileSize"
                class="d-inline-block mr-1"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="searchPayload.to" @input="endMenu = false" locale="ko" :min="searchPayload.from"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2" :style="searchHeight" class="pl-0 pb-0 pt-6">접수번호</v-col>
        <v-col cols="4" class="pr-0">
          <v-text-field
            v-model="searchPayload.receipt_from"
            outlined
            dense
            class="d-inline-block mr-1"
            :style="textNumberSize"
            placeholder="접수번호 입력"
            @keypress.enter="execSearch(true)"
            hide-details
          ></v-text-field>
          ~
          <v-text-field
            v-model="searchPayload.receipt_to"
            outlined
            dense
            class="d-inline-block mr-1"
            :style="textNumberSize"
            placeholder="접수번호 입력"
            @keypress.enter="execSearch(true)"
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row :style="searchHeight" class="mb-4 ml-0" cols="12">
        <v-col cols="2" :style="searchHeight" class="pl-0 pb-0 pt-6">신청자 이름</v-col>
        <v-col cols="4">
          <v-text-field
            v-model="searchPayload.member_name"
            outlined
            dense
            class="mr-1"
            placeholder="이름 입력"
            :style="{ width: '86%' }"
            @keypress.enter="execSearch(true)"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="2" :style="searchHeight" class="pl-0 pb-0 pt-6">신청자 핸드폰</v-col>
        <v-col cols="4" class="pr-0">
          <v-text-field
            v-model="searchPayload.member_phone"
            outlined
            dense
            class="mr-1"
            placeholder="핸드폰 입력"
            @keypress.enter="execSearch(true)"
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="mb-0 ml-0" cols="12">
        <v-col cols="2" :style="searchHeight" class="pb-0 pt-6 pl-0">A/S 상태</v-col>
        <v-col cols="4">
          <v-select
            v-model="searchPayload.status"
            :items="statusItems"
            label="Select"
            persistent-hint
            single-line
            class="pt-0"
            outlined
            dense
            :style="{ width: '86%' }"
          ></v-select>
        </v-col>
        <v-col cols="2" :style="searchHeight" class="pb-0 pt-6 pl-0">신청자 회원 ID</v-col>
        <v-col cols="4" class="pr-0">
          <v-text-field
            v-model="searchPayload.member_id"
            outlined
            dense
            class="mr-1"
            placeholder="아이디 입력"
            @keypress.enter="execSearch(true)"
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="row justify-center mb-10">
        <v-btn large color="grey darken-4" class="white--text" width="100" @click.prevent="execSearch(true)">조회</v-btn>
        <v-btn large style="margin-left: 20px;" width="100" @click.prevent="resetSearch">초기화</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      isSearching: false,
      textNumberSize: {
        height: "50px",
        width: "130px",
      },
      textFileSize: {
        height: "50px",
        width: "110px",
      },
      searchHeight: {
        height: "50px",
      },
      startMenu: false,
      endMenu: false,
      searchPayload: {
        from: "",
        to: "",
        receipt_from: "",
        receipt_to: "",
        receipt_no: "",
        member_name: "",
        member_phone: "",
        member_id: "",
        status: "",
        limit: 20,
        offset: 0,
      },
      statusItems: [
        { text: "전체", value: "" },
        { text: "접수 대기 중", value: "receipt_waiting" },
        { text: "접수 완료", value: "receipt_done" },
        { text: "센터 입고", value: "center_in" },
        { text: "입금 대기 중", value: "payment_waiting" },
        { text: "입금 완료", value: "payment_done" },
        { text: "A/S 완료", value: "as_done" },
        { text: "출고 완료", value: "shipping_done" },
        { text: "처리 완료", value: "done" },
      ],
    };
  },
  mixins: [CommonMixin],
  created: function() {
    this.eventHub.$on("execSearch", this.execSearch);
    this.eventHub.$on("getPayload", this.getPayload);
  },
  beforeDestroy: function() {
    this.eventHub.$off("execSearch", this.execSearch);
    this.eventHub.$off("getPayload", this.getPayload);
  },
  mounted: function() {
    this.resetSearch();
  },
  methods: {
    execSearch: function(init = false) {
      console.log("execSearch", init, this.searchPayload);
      this.$nextTick(function() {
        if (init === true) {
          // options 객체를 통째로 교체하지 말고 속성만 변경 (watcher 중복 실행 방지)
          this.$parent.$refs.listComponent.options.page = 1;
          this.$parent.$refs.listComponent.options.itemsPerPage = this.searchPayload.limit;
          this.searchPayload.offset = 0;
          this.searchPayload.limit = this.$parent.$refs.listComponent.options.itemsPerPage;
          this.getAsList(this.searchPayload);
        } else {
          let { page, itemsPerPage } = this.$parent.$refs.listComponent.options;
          this.searchPayload.offset = (page - 1) * itemsPerPage;
          this.searchPayload.limit = itemsPerPage;
          this.getAsList(this.searchPayload);
        }
      });
    },
    resetSearch: function() {
      this.searchPayload = {
        from: "",
        to: "",
        receipt_from: "",
        receipt_to: "",
        member_name: "",
        member_phone: "",
        member_id: "",
        status: "",
        limit: 20,
        offset: 0,
      };
      let before1Month = new Date();
      before1Month.setMonth(before1Month.getMonth() - 1);
      let toDay = new Date();
      this.searchPayload.from = M.yyyymmdd(before1Month);
      this.searchPayload.to = M.yyyymmdd(toDay);
    },
    getPayload: function() {
      return this.searchPayload;
    },
    buildSearchPayload: function(payload) {
      if (payload.receipt_from && payload.receipt_to) {
        delete payload.receipt_no;
      } else if (payload.receipt_from && !payload.receipt_to) {
        payload.receipt_no = payload.receipt_from;
        delete payload.receipt_from;
        delete payload.receipt_to;
      } else {
        delete payload.receipt_from;
        delete payload.receipt_to;
        delete payload.receipt_no;
      }
      return payload;
    },
    getAsList: async function(payload) {
      console.log("getAsList", this.isSearching, payload);
      if (this.isSearching) {
        return;
      }
      this.isSearching = true;
      this.$parent.$refs.listComponent.tableLoading = true;
      try {
        await this.waitForShopNo();
        const data = await M.api(M.entry("/as/search"), this.buildSearchPayload(payload));
        this.$parent.$refs.listComponent.setAsList(data);
      } catch (e) {
        this.alertShow("A/S 내역 조회에 실패했습니다. 잠시 후 다시 시도해주세요.");
        /*
        if (confirm("테스트를 위해 샘플 데이터 셋팅할래?")) {
          const sampleData = {
            count: 2,
            as_list: [
              {
                receipt_no: "A00001",
                receipt_seq: 29694,
                received_at: "2024-11-21 13:25:47",
                status: "receipt_waiting",
                member: {
                  id: "leehb12",
                  name: "이영호",
                  phone: "010-1234-5678",
                  email: "leehb12@gmail.com",
                  level: "정상 회원",
                },
                product: {
                  product_name: "테스트상품 3",
                  variant_name: "S",
                  product_code: "P000000K",
                  variant_code: "P000000K000A",
                  auth_code: "T8QU-AC90-RP3R-S5EJ",
                  purchase_store: "백화점",
                  purchase_year: "2023",
                },
                request: {
                  symptom: "본체 손상",
                  detail: "상세 증상 내용",
                  sender: "보내는 곳 주소",
                  receiver: "받는 곳 주소",
                  attachments: [{ name: "photo1.png", url: "https://.../photo1.png" }],
                },
                status_dates: {
                  receipt_done: "2024-11-22",
                  center_in: "2024-11-23",
                  payment_waiting: "2024-11-24",
                  payment_done: "2024-11-25",
                  as_done: "2024-11-26",
                  shipping_done: "2024-11-27",
                  done: "2024-11-28",
                },
                remark: {
                  repair_amount: 10000,
                  tracking_no: "1234567890",
                  memo: "메모",
                  updated_at: "2024-11-28 10:12:33",
                },
              },
              {
                receipt_no: "A00002",
                receipt_seq: 29695,
                received_at: "2024-11-21 13:25:47",
                status: "receipt_waiting",
                member: {
                  id: "leehb13",
                  name: "이영호",
                  phone: "010-1234-5678",
                  email: "leehb13@gmail.com",
                  level: "정상 회원",
                },
                product: {
                  product_name: "테스트상품 3",
                  variant_name: "S",
                  product_code: "P000000K",
                  variant_code: "P000000K000A",
                  auth_code: "T876-AC90-NDVZ-UA19",
                  purchase_store: "백화점",
                  purchase_year: "2023",
                },
                request: {
                  symptom: "본체 손상",
                  detail: "상세 증상 내용",
                  sender: "보내는 곳 주소",
                  receiver: "받는 곳 주소",
                  attachments: [{ name: "photo1.png", url: "https://.../photo1.png" }],
                },
                status_dates: {
                  receipt_done: "2024-11-22",
                  center_in: "2024-11-23",
                  payment_waiting: "2024-11-24",
                  payment_done: "",
                  as_done: "",
                  shipping_done: "",
                  done: "",
                },
                remark: {
                  repair_amount: 0,
                  tracking_no: "",
                  memo: "",
                  updated_at: "",
                },
              },
            ],
          };
          this.$parent.$refs.listComponent.setAsList(sampleData);
        }
          */
      } finally {
        this.isSearching = false;
        this.$parent.$refs.listComponent.tableLoading = false;
      }
    },
  },
};
</script>
